// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"f09c7d68","649":"195cdcce","742":"f09c7d68","823":"195cdcce"}[chunkId] + ".css";
};